import { isHtmlElement } from './isHtmlElement';
import { scrollTo } from './scrollTo';

export const scrollToAndFocusElement = (element: any): void => {
  if (isHtmlElement(element)) {
    scrollTo(element);
    element.focus({ preventScroll: true });
  }
};
